// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oxpU","comment":"styles_comment__2Own6"};